<template>
  <div class="container">
    <app-page-search :title="title"></app-page-search>

    <p><a href="Контакты менеджеров компетенций и корневых экспертов">Контакты менеджеров компетенций и корневых экспертов</a></p>
    <p><iframe
        src="https://docs.google.com/spreadsheets/d/e/2PACX-1vRb11xjtc6fZHYx-sf5Oy_WwMWI7ZNf_xJl53c__oP4YqRcQm2GQrJ3u9pwKgSglQ0QArPM8J5gGp9l/pubhtml?widget=true&amp;headers=false"
        width="100%"
        height="550"
      ></iframe></p>

    <!-- <div class="competence-search">
      <div class="competence-search__title">
        <h1 class="competence-title">Выберите компетенцию</h1>
      </div>
      <div class="competence-search__filter competence-filter">
        <v-select
          :options="competencies"
          v-model="competence"
          label="title"
          placeholder="Компетенция"
        >
          <span slot="no-options">Совпадений не найдено</span>
        </v-select>
      </div>
    </div> -->

    <!-- <div class="managers-list">
      <div
        v-for="manager of managers"
        :key="manager.guid"
        class="manager"
      >
        <div
          v-if="manager.photo_url"
          :style="{ backgroundImage: `url(${manager.photo_url})` }"
          class="manager__photo"
        ></div>
        <svg
          v-else
          class="manager__photo"
        >
          <use xlink:href="#default-manager"></use>
        </svg>
        <div class="manager__info">
          <div
            class="manager-info__fio"
            v-text="getFullName(manager)"
          ></div>
          <a
            :href="`mailto:${manager.email}`"
            class="manager-info__email"
            v-text="manager.email"
          ></a>
        </div>
        <div class="manager__compenetencies">
          <div
            v-for="competence of manager.competencies"
            :key="competence.guid"
            class="manager__competence"
            v-text="competence.title"
          >
          </div>
        </div>
      </div>
    </div> -->
    <!-- 
    <div class="row">
      <div class="col-sm load-more">
        <button
          v-show="hasMore && !loading"
          class="btn btn-feedback btn-outline"
          @click="loadMore"
        >Загрузить ещё</button>
        <app-spinner v-show="loading"></app-spinner>
      </div>
    </div> -->
  </div>
</template>

<script>
import { AppPageSearch, AppSpinner } from "@/components";
import { loadManagers, loadCategories } from "@/api/competencies";

export default {
  name: "Managers",
  components: {
    AppPageSearch,
    AppSpinner
  },
  data: () => ({
    managers: [],
    title: "Менеджеры компетенций",
    competence: null,
    competencies: [],
    totalCount: "",
    page: 1,
    itemsPerPage: 8,
    loading: true
  }),
  computed: {
    hasMore() {
      return this.managers.length < this.totalCount;
    }
  },
  watch: {
    competence(newVal) {
      this.managers = [];
      const params = { page: this.page, per_page: this.itemsPerPage };

      if (newVal) params.competency = newVal.guid;
      this.loadManagers(params);
    },
    $route() {
      this.init();
    }
  },
  async created() {
    this.init();
    this.competencies = await loadCategories();
  },
  methods: {
    async init() {
      if (this.$route.query.title) {
        const k = this.$route.query.title.split(" ").shift();
        const response = await loadManagers({ k });
        this.managers = response.data;
        this.totalCount = 1;
        this.loading = false;
      } else {
        this.loadManagers({ page: this.page, per_page: this.itemsPerPage });
      }
    },
    async loadManagers(params) {
      this.loading = true;

      const response = await loadManagers(params);
      this.managers = this.managers.concat(response.data);
      this.totalCount = response.meta.pagination.total;

      this.loading = false;
    },
    getFullName(manager) {
      return `${manager.last} ${manager.first} ${manager.middle}`;
    },
    loadMore() {
      this.page += 1;
      const params = { page: this.page, per_page: this.itemsPerPage };
      if (this.competence) {
        params.competency = this.competence.guid;
      }
      this.loadManagers(params);
    }
  }
};
</script>
<style lang="scss" scoped>
.competence-search {
  display: flex;
  justify-content: space-between;
  padding-top: 25px;

  &__title {
    align-self: center;

    .competence-title {
      font-size: 20px;
      line-height: 23px;
      font-weight: bold;
    }
  }

  &__filter {
    width: 50%;
  }
}

.managers-list {
  padding-top: 30px;

  .manager {
    display: flex;
    align-items: center;
    padding-bottom: 40px;
    border-bottom: 1px solid #c4c4c4;
    padding-top: 40px;

    &:last-child {
      border-bottom: none;
    }

    &__photo {
      width: 111px;
      height: 111px;
      border-radius: 50%;
      margin-right: 87px;
      background-size: cover;
      background-position: center;
    }

    &__info {
      flex: 1 1 30%;
      a {
        color: #1c3b8d;
        font-size: 14px;
        line-height: 21px;
      }
      .manager-info__fio {
        color: #3b3b3b;
        font-size: 18px;
        line-height: 21px;
        margin-bottom: 7px;
      }
    }

    &__compenetencies {
      color: #9c9a9a;
      font-size: 16px;
      line-height: 19px;
      flex: 1 1 50%;
    }
  }
}

@include media-breakpoint-down(sm) {
  .competence-search {
    &__title {
      display: none;
    }

    &__filter {
      width: 100%;
    }
  }
  .managers-list {
    .manager {
      flex-wrap: wrap;

      &__photo {
        width: 85px;
        min-width: 85px;
        height: 85px;
        border-radius: 50%;
        margin-right: 25px;
        background-color: #c4c4c4;
      }

      &__info {
        flex: 1 1 33%;
        margin-right: 0;
      }

      &__compenetencies {
        margin-top: 40px;
      }
    }
  }
}
</style>
